/**
 * Utility functions for role-based access control
 */

// Admin roles that have access to admin panel and user management
export const ADMIN_ROLES = ['admin', 'director'];

// Elevated roles that have access to advanced features
export const ELEVATED_ROLES = ['admin', 'director', 'floor_manager', 'processor_team_lead', 'sales_team_lead'];

/**
 * Check if user has admin privileges
 */
export function hasAdminAccess(userRole?: string): boolean {
  if (!userRole) return false;
  return ADMIN_ROLES.includes(userRole.toLowerCase());
}

/**
 * Check if user has elevated privileges
 */
export function hasElevatedAccess(userRole?: string): boolean {
  if (!userRole) return false;
  return ELEVATED_ROLES.includes(userRole.toLowerCase());
}

/**
 * Check if user has a specific role
 */
export function hasRole(userRole?: string, requiredRole?: string): boolean {
  if (!userRole || !requiredRole) return false;
  return userRole.toLowerCase() === requiredRole.toLowerCase();
}

/**
 * Check if user has any of the specified roles
 */
export function hasAnyRole(userRole?: string, requiredRoles?: string[]): boolean {
  if (!userRole || !requiredRoles || requiredRoles.length === 0) return false;
  return requiredRoles.some(role => userRole.toLowerCase() === role.toLowerCase());
}